import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { MfaFlow } from "@/components/admin/MfaFlow";

export const Route = createFileRoute("/_authenticated/admin/security/setup-mfa")({
  head: () => ({
    meta: [
      { title: "Configurar verificación en dos pasos | Mostrando México" },
      { name: "description", content: "Registra tu app de autenticación para el panel." },
      { property: "og:title", content: "Configurar verificación en dos pasos | Mostrando México" },
      { property: "og:description", content: "Seguridad de la cuenta administrativa." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: Page,
});

function Page() {
  const done = useCallback(() => window.location.replace("/admin"), []);
  return <MfaFlow onVerified={done} />;
}
